import React from "react";
import Image from "next/image";

import shareableQuicklinks from "assets/teams/shareable-quicklinks.png";

import Link from "assets/iconsv2/link-16.svg";
import ArrowRight from "assets/icons/arrow-right.svg";

import TeamsHighlight from "./TeamsHighlight";

const TeamsSharedQuicklinks: React.FC = () => {
  return (
    <div>
      <TeamsHighlight
        dir="rtl"
        img={<Image alt="Shareable Quicklinks" src={shareableQuicklinks} layout="responsive" />}
      >
        <strong>
          <Link className="icon" />
          Shared Quicklinks
        </strong>

        <h4>
          No more “where&rsquo;s the link
          <br /> you shared yesterday?”
        </h4>
        <p>
          Convert long links into simple bookmarks for the whole team to access. Jump in to GitHub repos, open up
          project documentation and revisit the latest prototypes, effortlessly. Even set up your new members with
          everything they need, much faster.
        </p>
        <p>With Shared Quicklinks, it&rsquo;s easy to get everyone on the same page.</p>

        <a href="https://manual.raycast.com/quicklinks" target="_blank" rel="noreferrer">
          Learn about Quicklinks <ArrowRight className="icon" />
        </a>
      </TeamsHighlight>
    </div>
  );
};

export default TeamsSharedQuicklinks;
